import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ConstantsService } from 'src/app/services/constants.service';

import londonVideos from './london-Videos.json';
@Component({
  selector: 'app-london-city-videos',
  templateUrl: './london-city-videos.component.html',
  styleUrls: ['./london-city-videos.component.scss']
})
export class LondonCityVideosComponent implements OnInit {
  public skeltonArray = [];
  loading: boolean;
  videos = [];
  public from = `${this.constants.WINDOW_SWAP_TXT} - windows in London`;
  constructor(
    public constants: ConstantsService,
    public title: Title,
    private meta: Meta,
    private router: Router,
  ) {
    var skelton = [
      constants.SKELTON_CARD_IMG,
      constants.SKELTON_CARD_IMG,
      constants.SKELTON_CARD_IMG,
      constants.SKELTON_CARD_IMG,
      constants.SKELTON_CARD_IMG,
      constants.SKELTON_CARD_IMG,
      constants.SKELTON_CARD_IMG,
      constants.SKELTON_CARD_IMG,
      constants.SKELTON_CARD_IMG,
      constants.SKELTON_CARD_IMG,
      constants.SKELTON_CARD_IMG,
      constants.SKELTON_CARD_IMG,]
    this.skeltonArray = skelton;
  }


  ngOnInit(): void {
    setTimeout(() => {
      this.loading = true

    }, 500);
    setTimeout(() => {
      this.load();
    }, 3000);
    this.title.setTitle(`${this.constants.WINDOW_SWAP_TXT} in London`);
    this.meta.addTag({ name: 'keywords', content: `windowswap, window-swap, windowswap in London, window-swap in London, windows in London` });

    setTimeout(() => {
      this.meta.updateTag(
        { name: 'description', content: 'Open a new window in London.Look through windows shared by real people, and share yours to become a part of this global community.' },
        'name=description'
      )
    }, 4000)
  }
  load() {
    this.loading = false;
    this.videos = londonVideos;
  }
  getClickedVideo(event) {
    let videoid = event.target.name;
    let clickedVideo = this.videos.filter(e => e.url1 === videoid);
    let balanceVideo = this.videos.filter(e => e.url1 !== videoid);
    let video = [...clickedVideo, ...balanceVideo];
    this.router.navigateByUrl('/Window', { state: { cityVideo: video } });
  }
}
